import { Component, input } from '@angular/core';
import { CommonButtonRowWidget } from '@eforall/common';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

@Component({
	selector: 'collapsible-mobile-card',
	imports: [CommonButtonRowWidget, NgbAccordionModule],
	templateUrl: './collapsible-mobile-card.widget.html',
	styleUrl: './collapsible-mobile-card.widget.scss'
})


export class MobileCollapsibleCardWidget {

	public readonly header = input.required<string>();
	public readonly buttonText = input<string>('');

}